var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectionsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 120,
    viewBox: "0 0 162 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 71.1684L35.596 46.6941V5.71387H124.975V46.6941L134.571 71.1684H102.736C102.029 71.1684 101.455 71.7418 101.455 72.4491V72.4491C101.455 73.1563 102.029 73.7297 102.736 73.7297H134.571V77.7139H26V73.7297H57.3456C58.0529 73.7297 58.6263 73.1563 58.6263 72.4491V72.4491C58.6263 71.7418 58.0529 71.1684 57.3456 71.1684H26ZM122.362 7.99055H37.7902V45.7048H122.362V7.99055Z",
    fill: "#777081"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6885 17.7647L72 31H94V13L88.7761 22.1401L84.9261 15.7416L80.5948 22.1401L76.6885 17.7647Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.25 23.1248C102.25 27.4741 105.776 31 110.125 31C114.474 31 118 27.4741 118 23.1248C118 18.7754 114.474 15.2495 110.125 15.2495V23.1248H102.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.875 13C103.526 13 100 16.5259 100 20.8752H107.875V13Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59 17C59 20.3137 56.3137 23 53 23C49.6863 23 47 20.3137 47 17C47 13.6863 49.6863 11 53 11C56.3137 11 59 13.6863 59 17Z",
    fill: "#777081"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 32.8C45 28.4922 48.5817 25 53 25C57.4183 25 61 28.4922 61 32.8V35C61 36.1046 60.1046 37 59 37H47C45.8954 37 45 36.1046 45 35V32.8Z",
    fill: "#777081"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31 90C31 94.4183 27.4183 98 23 98C18.5817 98 15 94.4183 15 90C15 85.5817 18.5817 82 23 82C27.4183 82 31 85.5817 31 90Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 109.064C14 104.61 18.0294 101 23 101C27.9706 101 32 104.61 32 109.064V109.064C32 111.238 30.2378 113 28.064 113H17.936C15.7622 113 14 111.238 14 109.064V109.064Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61 95C61 99.4183 57.4183 103 53 103C48.5817 103 45 99.4183 45 95C45 90.5817 48.5817 87 53 87C57.4183 87 61 90.5817 61 95Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44 114.064C44 109.61 48.0294 106 53 106C57.9706 106 62 109.61 62 114.064V114.064C62 116.238 60.2378 118 58.064 118H47.936C45.7622 118 44 116.238 44 114.064V114.064Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91 90C91 94.4183 87.4183 98 83 98C78.5817 98 75 94.4183 75 90C75 85.5817 78.5817 82 83 82C87.4183 82 91 85.5817 91 90Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74 109.064C74 104.61 78.0294 101 83 101C87.9706 101 92 104.61 92 109.064V109.064C92 111.238 90.2378 113 88.064 113H77.936C75.7622 113 74 111.238 74 109.064V109.064Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121 95C121 99.4183 117.418 103 113 103C108.582 103 105 99.4183 105 95C105 90.5817 108.582 87 113 87C117.418 87 121 90.5817 121 95Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104 114.064C104 109.61 108.029 106 113 106C117.971 106 122 109.61 122 114.064V114.064C122 116.238 120.238 118 118.064 118H107.936C105.762 118 104 116.238 104 114.064V114.064Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M151 90C151 94.4183 147.418 98 143 98C138.582 98 135 94.4183 135 90C135 85.5817 138.582 82 143 82C147.418 82 151 85.5817 151 90Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M134 109.064C134 104.61 138.029 101 143 101C147.971 101 152 104.61 152 109.064V109.064C152 111.238 150.238 113 148.064 113H137.936C135.762 113 134 111.238 134 109.064V109.064Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2852 42H62.2852L56.3477 61H49.2227L43.2852 42Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2852 42L49.2227 61H56.3477L62.2852 42H43.2852ZM46.0055 44L50.693 59H54.8773L59.5648 44H46.0055Z",
    fill: "#777081"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71 37C71 35.8954 71.8954 35 73 35H114C115.105 35 116 35.8954 116 37V37C116 38.1046 115.105 39 114 39H73C71.8954 39 71 38.1046 71 37V37Z",
    fill: "#777081"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41 40C41 39.4477 41.4477 39 42 39H64C64.5523 39 65 39.4477 65 40V40C65 40.5523 64.5523 41 64 41H42C41.4477 41 41 40.5523 41 40V40Z",
    fill: "#777081"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionsIcon);
export default __webpack_public_path__ + "static/media/directions-icon.c0d751ee.svg";
export { ForwardRef as ReactComponent };